import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadsDrawingsService {
  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;
  private activeTabSubject = new BehaviorSubject<any>({
    tabName: 'home',
    isEdit: false
  }); // default tab
  activeTab$ = this.activeTabSubject.asObservable();
  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getAllFileList(val: any) {
    return this.http.post(this.apiUrl + ApiUrls.GetAllFileList, val);
  }

  ReUpload(val: any) {
    return this.http.post(this.apiUrl + ApiUrls.ReUpload, val);
  }

  switchTab(tabValue: any) {
    // if(!tabValue?.hasOwnProperty("isEdit")){
    //   tabValue.isEdit = true;
    // }
    this.activeTabSubject.next(tabValue);
  }

  getTab(){
    return this.activeTabSubject.asObservable();
  }

  updateFile(val: any) {
    return this.http.post(this.apiUrl + ApiUrls.UpdateFile, val);
  }

  deleteFile(id: any) {
    return this.http.post(this.apiUrl + ApiUrls.DeleteFile + id, {});
  }

  GetFileById(id: any) {
    return this.http.get(this.apiUrl + ApiUrls.GetFileById + id);
  }

  GetFileFromCloud(id: any) {
    return this.http.get(this.apiUrl + ApiUrls.GetFileFromCloud + id, {
      responseType: 'blob'
    });
  }

  GetFilesHierarchyById(val: any,) {
    console.log(val);
    return this.http.post(this.apiUrl + ApiUrls.GetFilesHierarchyById, val, {
      params: new HttpParams().set('fileId', val?.fileId)
    });

  }
  documentControlList(){
    return this.http.get(this.apiUrl + ApiUrls.documentControlList+'dc');
  }

  GetCommentById(id: any) {
    return this.http.get(this.apiUrl + ApiUrls.GetCommentById + id);
  }
}
